import React from "react";
import { useTranslation } from "react-i18next";
import BarChartStackedComplience from "../BarChartStackedComplience";

export default function ComplianceRate(props) {
  const { t } = useTranslation();
  return (
    <div>
      <BarChartStackedComplience
        avgcolors={["#BCC5D6"]}
        titles={[
          t("dashboard.coach.incompleteRate"),
          t("dashboard.coach.conditionalPassRate"),
        ]}
        colors={["#13C77A"]}
        fontColors={["#000000"]}
        colors2={["#FFBC13"]}
        fontColors2={["#000000"]}
        legends2={["Expired"]}
        colors3={["#4E2EE6"]}
        data={props.data}
        showTotal
        labelX={props.labelX}
        labelY={t("leftNavigation.sessions")}
        country={props.country}
      />
    </div>
  );
}